/**
 * Dependencies
 */
import Vue from 'vue'
import { getState } from './state'

/**
 * Set the opex summary data
 *
 * @param  {Object} state
 * @param  {Object} payload
 * @return {Void}
 */
const GET_DATA_SUCCESS = (state, payload) => {
    state.data = payload.data
    state.meta = payload.meta
    state.loaded = true
    state.currentPage = 1
    state.loadingData = false
}

/**
 * Set the opex summary failure state
 *
 * @param  {Object} state
 * @return {Void}
 */
const GET_DATA_FAILURE = (state) => {
    state.error = true
}

/**
 * Reset the state
 *
 * @param  {Object} state
 * @return {Void}
 */
const RESET_STATE = (state) => {
    let originalState = getState()
    for (let prop in originalState) {
        Vue.set(state, prop, originalState[prop])
    }
}

/**
 * Update the search term in the state object
 *
 * @param  {Object} state
 * @param  {String} term
 * @return {Void}
 */
const UPDATE_SEARCH_TERM = (state, term) => {
    state.searchTerm = term
}

/**
 * Go forward a page
 *
 * @param  {Object} state
 * @return {Void}
 */
const UPDATE_PAGE_NEXT = (state) => {
    state.currentPage++
}

/**
 * Go backward a page
 *
 * @param  {Object} state
 * @return {Void}
 */
const UPDATE_PAGE_PREV = (state) => {
    state.currentPage--
}

/**
 * Set the data loading attribute
 *
 * @param  {Object} state
 * @return {Void}
 */
const LOAD_DATA = (state) => {
    state.loadingData = true
}

/**
 * Show / hide the form
 *
 * @param  {Object} state
 * @return {Promise}
 */
const TOGGLE_CREATE_FORM = (state) => {
    state.showForm = !state.showForm
}

/**
 * Handle new opex success
 *
 * @param  {Object} state
 * @param  {Object} payload
 * @return {Promise}
 */
const NEW_OPEX_SUCCESS = (state, payload) => {
    state.data.push(payload)
}

/**
 * Set the updating indicator
 *
 * @param  {Object} state
 * @return {Promise}
 */
const SET_UPDATING = state => {
    state.updating = true
}

/**
 * Reset the updating indicator
 *
 * @param  {Object} state
 * @return {Promise}
 */
const RESET_UPDATING = state => {
    state.updating = false
}

/**
 * Handle new opex failure
 *
 * @param  {Object} state
 * @param  {Object} err
 * @return {Promise}
 */
const NEW_OPEX_FAILURE = (state, err) => {}

/**
 * Handle updating a successful opex modification request
 *
 * @param  {Object} state
 * @param  {Object} payload
 * @return {Promise}
 */
const REPLACE_OPEX = (state, payload) => {
    let idx = state.data.findIndex(i => i.id === payload.id)

    if (idx > -1) {
        state.data.splice(idx, 1, payload)
    }
}

/**
 * Delete an operating expense from the dataset
 *
 * @param  {Object} state
 * @param  {Number} id
 * @return {Promise}
 */
const DELETE_OPEX = (state, id) => {
    console.log(id)
    state.data = state.data.filter(i => i.id !== id)
}

export default {
    LOAD_DATA,
    RESET_STATE,
    DELETE_OPEX,
    SET_UPDATING,
    REPLACE_OPEX,
    RESET_UPDATING,
    UPDATE_PAGE_NEXT,
    UPDATE_PAGE_PREV,
    GET_DATA_SUCCESS,
    GET_DATA_FAILURE,
    NEW_OPEX_SUCCESS,
    NEW_OPEX_FAILURE,
    TOGGLE_CREATE_FORM,
    UPDATE_SEARCH_TERM
}



// WEBPACK FOOTER //
// ./src/state/modules/projects/single/opex-summary/mutations.js